<main class="fadeIn">
  <div class="container-fluid">
    <ng-container>
      <div class="row">
        <div class="col-12">
          <div class="header d-flex justify-content-between">
            <div class="d-flex">
              <a class="back tool-wrap position-relative" role="button" (click)="closeThis()">
                <div class="custom-tooltip tooltip-top" role="tooltip">
                  <div class="arrow"></div>
                  <div class="tooltip-inner"> Back </div>
                </div>
              </a>
              <h1><small>&nbsp;</small>{{header}}-{{batchId}}</h1>
            </div>

          </div>
        </div>
      </div>
      <div class="tab-section" *ngIf="show">
        <ul class="nav nav-tabs" role="tablist" id="moving-tabs">
          <div class="slider"></div>
          <li class="nav-item" role="presentation">
            <a class="nav-link" [ngClass]="{'active ': activeTab === 1}" id="pres-det-tab" data-bs-toggle="tab"
              (click)="switchTab(1)" data-bs-target="#presDet" role="tab" aria-controls="home"
              aria-selected="true">{{header}} DETAILS</a>
          </li>
          <li class="nav-item" role="presentation">
            <a class="nav-link" [ngClass]="{'active ': activeTab === 2}" id="res-tab" data-bs-toggle="tab"
              data-bs-target="#resData" (click)="switchTab(2);settable();" role="tab" aria-controls="profile"
              aria-selected="false">RESPONSE DATA</a>
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <div class="tab-pane with-scroll fade active show " *ngIf="activeTab === 1" id="presDet" role="tabpanel"
            aria-labelledby="pres-det-tab">
            <div class="row-item mb-2">
              <div class="form-heading mb-3">
                <h3 class="before-none flex-border"><span>Basic Info</span>
                  <div class="heading-border"></div>
                </h3>
              </div>
              <div class="row">
                <div class="col-4 ">
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Sender ID</label></div>
                    <div class="col detail-view">
                      <span class="pointer">-</span> {{headerInfo?.senderId | notEmpty :'NA'}}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Receiver ID</label></div>
                    <div class="col detail-view"> <span class="pointer">-</span>{{headerInfo?.receiverId | notEmpty
                      :'NA'}}
                    </div>
                  </div>
                  <div class="row mb-2" *ngIf="( subTypeEvm === subTypes.both) && headerInfo?.providerCode">
                    <div class="col-5"><label class="form-label">Provider ID</label></div>
                    <div class="col detail-view"> <span class="pointer">-</span>{{headerInfo?.providerCode | notEmpty
                      :'NA'}}
                    </div>
                  </div>
                  <div class="row mb-2" *ngIf="( subTypeEvm === subTypes.provider) && headerInfo?.providerCode">
                    <div class="col-5"><label class="form-label">Provider Types</label></div>
                    <div class="col detail-view"> <span class="pointer">-</span>{{headerInfo?.providerTypeCode |
                      notEmpty
                      :'NA'}}
                    </div>
                  </div>

                </div>
                <div class="col-4">
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Transaction Date</label>
                    </div>
                    <div class="col detail-view"> <span class="pointer">-</span>
                      {{headerInfo?.transactionDate | notEmpty :'NA'}}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Record Count</label></div>
                    <div class="col detail-view"> <span class="pointer">-</span>{{headerInfo?.recordCount | notEmpty
                      :'NA'}}
                    </div>
                  </div>
                  <div class="row mb-2" *ngIf="( subTypeEvm === subTypes.both) && headerInfo?.providerCode">
                    <div class="col-5"><label class="form-label">Provider Types</label></div>
                    <div class="col detail-view"> <span class="pointer">-</span>{{headerInfo?.providerTypeCode |
                      notEmpty
                      :'NA'}}
                    </div>
                  </div>

                </div>
                <div class="col-4">
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Disposition Flag</label>
                    </div>
                    <div class="col detail-view"> <span class="pointer">-</span>
                      {{headerInfo?.dispositionFlag | notEmpty :'NA'}}
                    </div>
                  </div>
                  <div class="row"
                    *ngIf="( subTypeEvm === subTypes.payer|| subTypeEvm === subTypes.both) && headerInfo?.payerCode">
                    <div class="col-5"><label class="form-label">Payer ID</label></div>
                    <div class="col detail-view"> <span class="pointer">-</span>{{headerInfo?.payerCode | notEmpty
                      :'NA'}}
                    </div>
                  </div>
                  <div class="row mb-2"
                    *ngIf="( subTypeEvm === subTypes.provider && subTypeEvm != subTypes.both) && headerInfo?.providerCode">
                    <div class="col-5"><label class="form-label">Provider ID</label></div>
                    <div class="col detail-view"> <span class="pointer">-</span>{{headerInfo?.providerCode | notEmpty
                      :'NA'}}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row-item mb-2">
              <div class="form-heading mb-3">
                <h3 class="before-none flex-border"><span>Member Details</span>
                  <div class="heading-border"></div>
                </h3>
              </div>
              <div class="row">
                <div class="col-4">
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Name</label></div>
                    <div class="col detail-view">
                      <span class="pointer">-</span> {{name | notEmpty :'NA'}}
                    </div>
                  </div>

                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Gender</label></div>
                    <div class="col detail-view">
                      <span class="pointer">-</span> {{prescription?.patient?.gender | notEmpty :'NA'}}
                    </div>
                  </div>

                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Date Of Birth</label></div>
                    <div class="col detail-view">
                      <span class="pointer">-</span> {{prescription?.patient?.dob | notEmpty :'NA'}}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Preferred Language</label>
                    </div>
                    <div class="col detail-view">
                      <span class="pointer">-</span>{{prescription?.patient?.preferredLanguage | notEmpty :'NA'}}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Gross</label></div>
                    <div class="col detail-view">
                      <span class="pointer">-</span>
                      {{prescription?.patient?.gross | notEmpty :'NA'}}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Net</label></div>
                    <div class="col detail-view">
                      <span class="pointer">-</span>
                      {{prescription?.patient?.net | notEmpty :'NA'}}
                    </div>
                  </div>


                </div>
                <div class="col-4">
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Contact Number</label>
                    </div>
                    <div class="col detail-view">
                      <span class="pointer">-</span>{{prescription?.patient?.phone | notEmpty :'NA'}}
                    </div>
                  </div>

                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Email</label></div>
                    <div class="col detail-view">
                      <span class="pointer">-</span> {{prescription?.patient?.email | notEmpty :'NA'}}
                    </div>
                  </div>

                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Blood Group</label></div>
                    <div class="col detail-view">
                      <span class="pointer">-</span> {{prescription?.patient?.bloodGroup | notEmpty :'NA'}}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">National ID Number</label>
                    </div>
                    <div class="col detail-view">
                      <span class="pointer">-</span> {{prescription?.patient?.nationalId | notEmpty :'NA'}}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Patient Share</label></div>
                    <div class="col detail-view">
                      <span class="pointer">-</span>
                      {{prescription?.patient?.patientShare | notEmpty :'NA'}}
                    </div>
                  </div>

                </div>
                <div class="col-4">
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Member ID</label></div>
                    <div class="col detail-view">
                      <span class="pointer">-</span> {{prescription?.patient?.memberCode | notEmpty :'NA'}}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Ehealth ID</label></div>
                    <div class="col detail-view">
                      <span class="pointer">-</span> {{prescription?.patient?.eHealthId | notEmpty :'NA' }}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Nationality</label></div>
                    <div class="col detail-view">
                      <span class="pointer">-</span>
                      {{prescription?.patient?.nationality | notEmpty :'NA'}}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Emirates ID</label></div>
                    <div class="col detail-view">
                      <span class="pointer">-</span>
                      {{prescription?.patient?.emiratesIDNumber | notEmpty :'NA'}}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Claim ID</label></div>
                    <div class="col detail-view">
                      <span class="pointer">-</span>
                      {{prescription?.patient?.claimId | notEmpty :'NA'}}
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div class="row-item mb-1">
              <div class="form-heading mb-3">
                <h3 class="before-none flex-border"><span>Encounter Details</span>
                  <div class="heading-border"></div>
                </h3>
              </div>
              <div class="row">
                <div class="col-4 ">
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Prescription ID</label></div>
                    <div class="col detail-view"> <span class="pointer">-</span>{{prescription?.id | notEmpty :'NA'}}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Clinician</label></div>
                    <div class="col detail-view"> <span class="pointer">-</span>{{prescription?.clinician | notEmpty
                      :'NA'}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">ID</label></div>
                    <div class="col detail-view"> <span class="pointer">-</span>{{prescription?.id | notEmpty :'NA'}}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Start Type</label></div>
                    <div class="col detail-view"> <span class="pointer">-</span>{{prescription?.encounter?.startType |
                      notEmpty :'NA'}}
                    </div>
                  </div>

                </div>
                <div class="col-4">
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Reference Number</label></div>
                    <div class="col detail-view"> <span class="pointer">-</span>{{prescription?.referenceNumber |
                      notEmpty
                      :'NA'}}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Facility ID</label></div>
                    <div class="col detail-view"> <span class="pointer">-</span>{{prescription?.encounter?.facility_id |
                      notEmpty :'NA'}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Date</label></div>
                    <div class="col detail-view"> <span class="pointer">-</span>{{headerInfo?.transactionDate | notEmpty
                      :'NA'}}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">End</label></div>
                    <div class="col detail-view"> <span class="pointer">-</span>{{ prescription?.encounter?.endOn |
                      notEmpty :'NA'}}
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Type</label></div>
                    <div class="col detail-view"> <span class="pointer">-</span>{{prescription?.type | notEmpty :'NA'}}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Facility Name</label></div>
                    <div class="col detail-view"> <span class="pointer">-</span>{{prescription?.encounter?.facility_name
                      |
                      notEmpty :'NA'}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Start</label></div>
                    <div class="col detail-view"> <span class="pointer">-</span>{{prescription?.encounter?.startOn |
                      notEmpty :'NA'}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">End Type</label></div>
                    <div class="col detail-view"> <span class="pointer">-</span>{{prescription?.encounter?.endtype |
                      notEmpty :'NA'}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row-item mb-2" *ngIf="prescription?.diagnosis?.length">
              <div class="form-heading form-sub-head mb-3">
                <h3 class="before-none flex-border"><span>DIAGNOSIS</span>
                  <div class="heading-border "></div>
                </h3>
              </div>
              <div class="row" *ngFor="let diagnosis of prescription?.diagnosis">
                <div class="col-4 ">
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Type</label></div>
                    <div class="col detail-view"> <span class="pointer">-</span>{{diagnosis?.diaganosisVersion |
                      notEmpty
                      :'NA'}}
                    </div>
                  </div>

                </div>
                <div class="col-4">
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Code</label></div>
                    <div class="col detail-view"> <span class="pointer">-</span>{{diagnosis?.diaganosisCode | notEmpty
                      :'NA'}}
                    </div>
                  </div>

                </div>
                <div class="col-4">
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Classification</label></div>
                    <div class="col detail-view"> <span class="pointer">-</span>{{diagnosis?.diaganosisClassification |
                      notEmpty :'NA'}}</div>
                  </div>

                </div>
              </div>
            </div>
            <div class="row-item mb-2">
              <div class="form-heading form-sub-head mb-3">
                <h3 class="before-none flex-border"><span>PATIENT OBSERVATION</span>
                  <div class="heading-border "></div>
                </h3>
              </div>
              <div class="row">
                <div class="col-4 ">
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Patient Height</label></div>
                    <div class="col detail-view"> <span
                        class="pointer">-</span>{{prescription?.encounter?.patientObservation?.height ||'NA'}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Patient Weight</label></div>
                    <div class="col detail-view"> <span
                        class="pointer">-</span>{{prescription?.encounter?.patientObservation?.weight ||'NA'}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Pregnancy Status</label></div>
                    <div class="col detail-view"
                      *ngIf="prescription?.encounter?.patientObservation?.pregnancyStatus == '0'"> <span
                        class="pointer">-</span>Not Pregnant</div>
                    <div class="col detail-view"
                      *ngIf="prescription?.encounter?.patientObservation?.pregnancyStatus == '1'"> <span
                        class="pointer">-</span> Pregnant</div>
                    <div class="col detail-view"
                      *ngIf="prescription?.encounter?.patientObservation?.pregnancyStatus == null "> <span
                        class="pointer">-</span>NA</div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Head Size</label></div>
                    <div class="col detail-view"> <span
                        class="pointer">-</span>{{prescription?.encounter?.patientObservation?.headSize | notEmpty
                      :'NA'}}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Occupation</label></div>
                    <div class="col detail-view"> <span
                        class="pointer">-</span>{{prescription?.encounter?.patientObservation?.occupation | notEmpty
                      :'NA'}}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Marital Status</label></div>
                    <div class="col detail-view"> <span
                        class="pointer">-</span>{{prescription?.encounter?.patientObservation?.maritalStatus | notEmpty
                      :'NA'}}
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Patient Status</label></div>
                    <div class="col detail-view"> <span
                        class="pointer">-</span>{{prescription?.encounter?.patientObservation?.patientStatus| notEmpty
                      :'NA' }}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Age</label></div>
                    <div class="col detail-view"> <span
                        class="pointer">-</span>{{prescription?.encounter?.patientObservation?.age ||'NA'}}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Lactating</label></div>
                    <div class="col detail-view" *ngIf="prescription?.encounter?.patientObservation?.lactating == '0'">
                      <span class="pointer">-</span>False
                    </div>
                    <div class="col detail-view" *ngIf="prescription?.encounter?.patientObservation?.lactating == '1'">
                      <span class="pointer">-</span> True
                    </div>
                    <div class="col detail-view"
                      *ngIf="prescription?.encounter?.patientObservation?.lactating == null ">
                      <span class="pointer">-</span>NA
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row-item mb-2" *ngFor="let signs of prescription?.encounter?.vitalSigns">
              <div class="form-heading form-sub-head mb-3">
                <h3 class="before-none flex-border"><span>Vital Signs</span>
                  <div class="heading-border "></div>
                </h3>
              </div>
              <div class="row">
                <div class="col-4 ">
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Vital Signs Type</label>
                    </div>
                    <div class="col detail-view"> <span class="pointer">-</span>{{signs.vitalSignType | notEmpty :'NA'}}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Vital Signs Value
                        Type</label></div>
                    <div class="col detail-view"> <span class="pointer">-</span>{{signs.vitalSignsValueType | notEmpty
                      :'NA'}}
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Vital Signs Value</label>
                    </div>
                    <div class="col detail-view"> <span class="pointer">-</span>{{signs.vitalSignsValue | notEmpty
                      :'NA'}}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Systolic</label></div>
                    <!-- systolic/diastolic are mmHg readings, not flags. Rendering them as
                         True/False/NA left every real reading showing nothing at all. -->
                    <div class="col detail-view"><span class="pointer">-</span>{{signs.systolic | notEmpty :'NA'}}</div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="row mb-2">
                    <div class="col-5"><label class="form-label">Diastolic</label></div>
                    <div class="col detail-view"> <span class="pointer">-</span>{{signs.diastolic | notEmpty :'NA'}}</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Lifted out of the vital-signs *ngFor above: nested there, the whole
                 allergy list was re-rendered once per vital sign. -->
            <div class="row-item mb-2" *ngIf="prescription?.encounter?.allergyCodes?.length">
              <div class="form-heading form-sub-head mb-3">
                <h3 class="before-none flex-border"><span>Allergy codes</span>
                  <div class="heading-border "></div>
                </h3>
              </div>
              <div class="row">
                <ng-container *ngFor="let code of prescription?.encounter?.allergyCodes">
                  <div class="col-4">
                    <div class="row mb-2">
                      <div class="col-5"><label class="form-label">Code</label></div>
                      <div class="col detail-view"> <span class="pointer">-</span>{{code.allergyCode | notEmpty
                        :'NA'}}
                      </div>
                    </div>

                  </div>
                  <div class="col-4">
                    <div class="row mb-2">
                      <div class="col-5"><label class="form-label">Severity</label></div>
                      <div class="col detail-view"> <span class="pointer">-</span> {{code.severity | notEmpty :'NA'}}
                      </div>
                    </div>

                  </div>
                  <div class="col-4">
                    <div class="row mb-2">
                      <div class="col-5"><label class="form-label">Type</label></div>
                      <div class="col detail-view"> <span class="pointer">-</span>{{code.allergyType | notEmpty
                        :'NA'}}
                      </div>
                    </div>

                  </div>
                </ng-container>
              </div>
            </div>
            <div class="row-item mb-2 mt-4">
              <div class="tab-section">
                <ul class="nav nav-tabs" role="tablist" id="moving-tabs1">
                  <div class="slider"></div>
                  <li class="nav-item" role="presentation" *ngFor="let activity of prescription?.activity;let i=index">
                    <a class="nav-link " [ngClass]="{active: i===currentActivity}" (click)="currentActivity=i;"
                      id="act-tab" data-bs-toggle="tab" data-bs-target="#act-tabitem" role="tab" aria-controls="home"
                      aria-selected="true">ACTIVITY {{i+1}}</a>
                  </li>

                </ul>
                <div class="tab-content" id="myTabContent">
                  <div class="tab-pane fade active show " id="act-tabitem" role="tabpanel" aria-labelledby="act-tab">
                    <div class="row">
                      <div class="col-4 ">
                        <div class="row mb-2">
                          <div class="col-5"><label class="form-label">Drug Name</label></div>
                          <div class="col detail-view"> <span
                              class="pointer">-</span>{{prescription?.activity?.[currentActivity]?.drugName | notEmpty
                            :'NA'}}
                          </div>
                        </div>
                        <div class="row mb-2">
                          <div class="col-5"><label class="form-label">ID</label></div>
                          <div class="col detail-view"> <span
                              class="pointer">-</span>{{prescription?.activity?.[currentActivity]?.unitId | notEmpty
                            :'NA'}}
                          </div>
                        </div>
                        <div class="row mb-2">
                          <div class="col-5"><label class="form-label">Type</label></div>
                          <div class="col detail-view"> <span
                              class="pointer">-</span>{{prescription?.activity?.[currentActivity]?.activityType |
                            notEmpty
                            :'NA'}}
                          </div>
                        </div>
                        <div class="row mb-2">
                          <div class="col-5"><label class="form-label">Indication</label></div>
                          <div class="col detail-view"> <span
                              class="pointer">-</span>{{prescription?.activity?.[currentActivity]?.indication | notEmpty
                            :'NA'}}
                          </div>
                        </div>
                        <div class="row mb-2">
                          <div class="col-5"><label class="form-label">Code</label></div>
                          <div class="col detail-view"> <span
                              class="pointer">-</span>{{prescription?.activity?.[currentActivity]?.drugCode | notEmpty
                            :'NA'}}
                          </div>
                        </div>
                        <div class="row mb-2">
                          <div class="col-5"><label class="form-label">Quantity</label></div>
                          <div class="col detail-view"> <span
                              class="pointer">-</span>{{prescription?.activity?.[currentActivity]?.quantity | notEmpty
                            :'NA'}}
                          </div>
                        </div>

                      </div>
                      <div class="col-4">
                        <div class="row mb-2">
                          <div class="col-5"><label class="form-label">Duration</label></div>
                          <div class="col detail-view"> <span
                              class="pointer">-</span>{{prescription?.activity?.[currentActivity]?.duration | notEmpty
                            :'NA'}}
                          </div>
                        </div>
                        <div class="row mb-2">
                          <div class="col-5"><label class="form-label">Unit Id</label></div>
                          <div class="col detail-view"> <span
                              class="pointer">-</span>{{prescription?.activity?.[currentActivity]?.unitId | notEmpty
                            :'NA'}}
                          </div>
                        </div>
                        <div class="row mb-2">
                          <div class="col-5"><label class="form-label">Single Dose ID</label></div>
                          <div class="col detail-view"> <span
                              class="pointer">-</span>{{prescription?.activity?.[currentActivity]?.singleDoseID |
                            notEmpty
                            :'NA'}}
                          </div>
                        </div>
                        <div class="row mb-2">
                          <div class="col-5"><label class="form-label">Refills</label></div>
                          <div class="col detail-view"
                            *ngIf="prescription?.activity?.[currentActivity]?.hasRefill == 1">
                            <span class="pointer">-</span>True
                          </div>
                          <div class="col detail-view"
                            *ngIf="prescription?.activity?.[currentActivity]?.hasRefill == 0">
                            <span class="pointer">-</span>False
                          </div>
                          <div class="col detail-view"
                            *ngIf="prescription?.activity?.[currentActivity]?.hasRefill == null"> <span
                              class="pointer">-</span>NA</div>
                        </div>
                        <div class="row mb-2">
                          <div class="col-5"><label class="form-label">PRN</label></div>
                          <div class="col detail-view"> <span class="pointer">-</span>False</div>
                        </div>
                        <div class="row mb-2">
                          <div class="col-5"><label class="form-label">Instructions</label></div>
                          <div class="col detail-view"> <span
                              class="pointer">-</span>{{prescription?.activity?.[currentActivity]?.instructions |
                            notEmpty
                            :'NA'}}
                          </div>
                        </div>

                      </div>
                      <div class="col-4">
                        <div class="row mb-2">
                          <div class="col-5"><label class="form-label">Arabic Instructions</label></div>
                          <div class="col detail-view"> <span
                              class="pointer">-</span>{{prescription?.activity?.[currentActivity]?.arabicInstructions |
                            notEmpty :'NA'}}
                          </div>
                        </div>
                        <div class="row mb-2">
                          <div class="col-5"><label class="form-label">Rout Of Admin</label></div>
                          <div class="col detail-view"> <span
                              class="pointer">-</span>{{prescription?.activity?.[currentActivity]?.routeOfAdmin |
                            notEmpty
                            :'NA'}}
                          </div>
                        </div>
                        <div class="row mb-2">
                          <div class="col-5"><label class="form-label">Start Date</label></div>
                          <div class="col detail-view"> <span
                              class="pointer">-</span>{{prescription?.activity?.[currentActivity]?.activityStartDate |
                            notEmpty :'NA'}}
                          </div>
                        </div>
                        <div class="row mb-2">
                          <div class="col-5"><label class="form-label">Instruction Type</label></div>
                          <div class="col detail-view"> <span
                              class="pointer">-</span>{{prescription?.activity?.[currentActivity]?.instructionType |
                            notEmpty :'NA'}}
                          </div>
                        </div>
                        <div class="row mb-2">
                          <div class="col-5"><label class="form-label">Is Flexed</label></div>
                          <div class="col detail-view" *ngIf="prescription?.activity?.[currentActivity]?.isFlexed == 1">
                            <span class="pointer">-</span>True
                          </div>
                          <div class="col detail-view" *ngIf="prescription?.activity?.[currentActivity]?.isFlexed == 0">
                            <span class="pointer">-</span>False
                          </div>
                          <div class="col detail-view"
                            *ngIf="prescription?.activity?.[currentActivity]?.isFlexed == null"> <span
                              class="pointer">-</span>NA</div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <hr class="doted" />
                    </div>
                    <div class="row mb-3">
                      <div class="col-12">
                        <h4>Frequencies</h4>
                      </div>
                    </div>
                    <div class="row"
                      *ngFor="let item of prescription?.activity?.[currentActivity]?.frequencies; let i=index ; last as isLast">
                      <div class="col-4 ">
                        <div class="row mb-2">
                          <div class="col-5"><label class="form-label">Unit Per Frequency</label></div>
                          <div class="col detail-view"> <span class="pointer">-</span>{{item?.unitPerFrequency |
                            notEmpty
                            :'NA'}}
                          </div>
                        </div>
                        <div class="row mb-2">
                          <div class="col-5"><label class="form-label">Frequency Value</label></div>
                          <div class="col detail-view"> <span class="pointer">-</span>{{item?.frequencyValue | notEmpty
                            :'NA'}}
                          </div>
                        </div>
                        <div class="row mb-2">
                          <div class="col-5"><label class="form-label">Frequency Type</label></div>
                          <div class="col detail-view"> <span class="pointer">-</span>{{item?.frequencyType | notEmpty
                            :'NA'}}
                          </div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="row mb-2">
                          <div class="col-5"><label class="form-label">Dosage As Needed</label></div>
                          <div class="col detail-view"> <span class="pointer">-</span>{{item?.dosageAsNeeded | notEmpty
                            :'NA'}}
                          </div>
                        </div>
                        <div class="row mb-2">
                          <div class="col-5"><label class="form-label">Quantity</label></div>
                          <div class="col detail-view"> <span class="pointer">-</span>{{item?.freqQuantity | notEmpty
                            :'NA'}}</div>
                        </div>
                        <div class="row mb-2">
                          <div class="col-5"><label class="form-label">Duration</label></div>
                          <div class="col detail-view"> <span class="pointer">-</span>{{item?.freqDuration | notEmpty
                            :'NA'}}</div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="row mb-2">
                          <div class="col-5"><label class="form-label">Repeat Pattern</label></div>
                          <div class="col detail-view"> <span class="pointer">-</span>{{item?.repeatPattern | notEmpty
                            :'NA'}}
                          </div>
                        </div>
                        <div class="row mb-2">
                          <div class="col-5"><label class="form-label">Frequency Precondition</label></div>
                          <div class="col detail-view"> <span class="pointer">-</span>{{item?.frequencyPrecondition |
                            notEmpty :'NA'}}</div>
                        </div>
                      </div>
                      <div class="row" *ngIf="!isLast">
                        <hr class="doted" />
                      </div>
                    </div>

                    <div class="row">
                      <hr class="doted" />
                    </div>
                    <div class="row mb-3">
                      <div class="col-12">
                        <h4>Observation</h4>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-4 ">
                        <div class="row mb-2">
                          <div class="col-5"><label class="form-label">Type</label></div>
                          <div class="col detail-view"> <span
                              class="pointer">-</span>{{prescription?.activity?.[currentActivity]?.observation?.[0]?.observationType
                            | notEmpty :'NA'}}
                          </div>
                        </div>
                        <div class="row mb-2">
                          <div class="col-5"><label class="form-label">Code</label></div>
                          <div class="col detail-view"> <span
                              class="pointer">-</span>{{prescription?.activity?.[currentActivity]?.observation?.[0]?.observationCode
                            | notEmpty :'NA'}}
                          </div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="row mb-2">
                          <div class="col-5"><label class="form-label">Value</label></div>
                          <div class="col detail-view"> <span
                              class="pointer">-</span>{{prescription?.activity?.[currentActivity]?.observation?.[0]?.observationValue
                            | notEmpty :'NA'}}
                          </div>
                        </div>
                        <div class="row mb-2">
                          <div class="col-5"><label class="form-label">Value Type</label></div>
                          <div class="col detail-view"> <span
                              class="pointer">-</span>{{prescription?.activity?.[currentActivity]?.observation?.[0]?.observationValueType
                            | notEmpty :'NA'}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane fade" id="act-tab1" role="tabpanel" aria-labelledby="act-tab1">
                  </div>
                </div>
              </div>

            </div>

            <div class="row-item mb-2" *ngIf="prescription?.comments">
              <div class="form-heading mb-3">
                <h3 class="before-none flex-border"><span>Comments</span>
                  <div class="heading-border"></div>
                </h3>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="row mb-2">
                    <div class="col detail-view f-500">{{prescription?.comments}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane with-scroll fade active show" *ngIf="activeTab === 2" id="resData" role="tabpanel"
            aria-labelledby="res-tab">
            <div class="row" *ngIf="capPrescriptionResponse?.length">
              <div class="col-12">
                <div class="acc-wrap " [ngClass]="{'expanded ':isCapValidionOpen}">
                  <div class="acc-wrap-head" (click)="toggleCap()">
                    <a role="button" class="sub-menu-btn"></a>
                    <h4>Prescription level Validation</h4>
                  </div>
                  <div class="table-responsive table-response-data validation-table fade active show fade-in-main">
                    <table id="responseDataTable" class="table with-hover-class res-table res-table-updated">
                      <caption class="d-none">CAP Validation (Prescription level) table body</caption>
                      <thead class="d-none">
                        <tr>
                          <th class="sr-only" scope="col">Validation</th>
                          <th class="sr-only" scope="col">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let capPrescription of capPrescriptionResponse">
                          <td>{{capPrescription.capValidationMessage | notEmpty}}</td>
                          <td>
                            <div class="test-case pass" *ngIf="checkValidationSataus(capPrescription.validationStatus)">
                              <img src="assets/images/icons/test-case-pass.svg" alt="Pass image">Pass
                            </div>
                            <div class="test-case fail"
                              *ngIf="!checkValidationSataus(capPrescription.validationStatus)">
                              <img src="assets/images/icons/test-case-fail.svg" alt="Pass image">Fail
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                  </div>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="prescriptionResponse?.length">
              <div class="col-12">
                <div class=" benefit-map-table">
                  <div class="fixed-lift-table package-Liability">
                    <div class="left-table">
                      <div class="table-responsive table-response-data mb-0">

                        <table id="table-response-drugname" class="table">
                          <caption></caption>
                          <thead>
                            <tr>

                              <th scope="col">DRUG NAME
                              </th>
                            </tr>

                          </thead>
                          <tbody class="respo-body" [ngClass]="{'respo-scroll-less': !capPrescriptionResponse.length}"
                            *ngIf="prescriptionResponse" #rightTable (scroll)="handleScroll($event)">
                            <tr *ngFor="let res of prescriptionResponse">

                              <td style="height: 383px; width: 125px;">{{setDrugName(res)}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="liability-scroll">
                      <div class="table-responsive table-response-data">

                        <table id="responseDataTable" class="table with-hover-class res-table res-table-updated">
                          <caption class="d-none">Response data table body</caption>
                          <thead>
                            <tr>
                              <th scope="col" style="width: 400px;">Clinical RESPONSE</th>
                              <th scope="col" style="width: 200px;">Dispense Response</th>
                              <th scope="col" style="width: 200px;"></th>
                              <th scope="col" style="width: 200px;"></th>
                              <th scope="col" style="width: 500px;">Pre-Validations</th>
                              <th scope="col" style="width: 500px;">Cap Validations</th>
                              <th scope="col" style="width: 210px;">Status</th>
                              <th scope="col" style="width: 330px;">Action</th>
                            </tr>
                          </thead>
                          <tbody class="respo-body" [ngClass]="{'respo-scroll-less': !capPrescriptionResponse.length}"
                            *ngIf="prescriptionResponse" #leftTable (scroll)="handleScroll($event)">
                            <tr *ngFor="let res of prescriptionResponse;let index=index;">
                              <td style="min-width: 400px;">
                                <div class="data-res-row" *ngIf="res?.clinical[0]?.status !== 'passed'">
                                  <p class="data-res-inner dr-head">Clinical Validation</p>
                                  <p class="data-res-inner dr-head">Importance</p>
                                  <p class="data-res-inner dr-head"></p>
                                </div>
                                <div class="response-scroll" *ngIf="res?.clinical[0]?.status !== 'passed'">
                                  <ng-container *ngIf="res?.clinical">
                                    <div class="accordion acc-res" *ngFor="let item of res?.clinical;let i = index;">
                                      <div class="accordion-item" *ngIf="i < count">
                                        <div class="accordion-header" id="headingOne">
                                          <button class="accordion-button " type="button"
                                            [ngClass]="{'collapsed':!item?.showDetails}" (click)="showItemDetails(item)"
                                            data-bs-toggle="collapse" data-bs-target="#cval" aria-expanded="true"
                                            aria-controls="cval">
                                            <div class="data-res-row">
                                              <p class="data-res-inner dr-content bg-pass" style="max-width: 145px;"
                                                *ngIf="item.status == 'passed'">There is no contradiction<br> in
                                                clinical validations</p>
                                              <p class="data-res-inner dr-content" *ngIf="item.status !== 'passed'">
                                                {{item?.apiName || '-'}}</p>
                                              <p class="data-res-inner dr-content response-indication very-high"
                                                *ngIf="item?.importance === 'Very High'">{{item?.importance}}</p>
                                              <p class="data-res-inner dr-content response-indication high"
                                                *ngIf="item?.importance === 'High'">{{item?.importance}}</p>
                                              <p class="data-res-inner dr-content response-indication low"
                                                *ngIf="item?.importance === 'Low'">{{item?.importance}}</p>
                                              <p class="data-res-inner dr-content response-indication medium"
                                                *ngIf="item?.importance === 'Medium'">{{item?.importance}}</p>
                                              <p class="data-res-inner dr-content response-indication passed"
                                                *ngIf="item?.importance === 'Passed'">{{item?.importance}}</p>
                                              <p class="data-res-inner dr-content response-indication very-low"
                                                *ngIf="item?.importance === 'Very Low'">{{item?.importance}}</p>
                                              <div class="data-res-inner dr-content" *ngIf="item.clinicalStatus===1">
                                                <div class="test-case fail">
                                                  <img src="assets/images/icons/test-case-fail.svg"
                                                    alt="fail image">Fail
                                                </div>
                                              </div>
                                              <div class="data-res-inner dr-content" *ngIf="item.clinicalStatus===0">
                                              </div>
                                            </div>
                                            <div class="arrow"></div>
                                          </button>
                                        </div>
                                        <div id="cval" class="accordion-collapse collapse"
                                          [ngClass]="{'show':item?.showDetails}" aria-labelledby="headingOne">
                                          <div class="accordion-body">
                                            <div class="data-row">
                                              <p class="dr-head">Text</p>
                                              <p class="dr-content">{{item?.text}}
                                              </p>
                                            </div>
                                            <div class="data-row">
                                              <p class="dr-head">Summary</p>
                                              <p class="dr-content">{{item?.summary}}</p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="text-center" *ngIf="(res?.clinical?.length) > count"
                                      (click)="updateCount(false);">
                                      <a class="res-link">{{res?.clinical?.length - count}} more Validation</a>
                                    </div>
                                    <div class="text-center" *ngIf="showLess && (res?.clinical?.length) <= count"
                                      (click)="updateCount(true);">
                                      <a class="res-link">Show Less</a>
                                    </div>
                                  </ng-container>
                                </div>
                                <div class="bg-pass d-flex justify-content-between"
                                  *ngIf="res?.clinical[0]?.status == 'passed'">
                                  <p>There is no contradiction in clinical validations</p>
                                  <div class="test-case pass"><img src="assets/images/icons/test-case-pass.svg"
                                      alt="Pass image">Pass
                                  </div>
                                </div>
                              </td>
                              <td style="min-width: 200px;">
                                <div class="data-row">
                                  <p class="dr-head">Brand Name</p>
                                  <p class="dr-content">{{res?.dispense?.brandName ||'-'}}</p>
                                </div>
                                <div class="data-row">
                                  <p class="dr-head">Price Per Packet</p>
                                  <p class="dr-content">{{res?.dispense?.price || '-'}}</p>
                                </div>
                                <div class="data-row">
                                  <p class="dr-head">Size Unit</p>
                                  <p class="dr-content">{{res?.dispense?.sizeUnit ||'-'}}</p>
                                </div>
                                <div class="data-row">
                                  <p class="dr-head">Quantity to be Dispensed</p>
                                  <p class="dr-content"
                                    *ngIf="!res.dispense.maxRefillAppliedQuantity || res.dispense.maxRefillAppliedQuantity < 0">
                                    {{res?.dispense?.totalQuantity ||'-'}}</p>
                                  <p class="dr-content" *ngIf="res.dispense.maxRefillAppliedQuantity > 0">
                                    {{res?.dispense?.maxRefillAppliedQuantity ||'-'}} / {{res?.dispense?.totalQuantity
                                    ||'-'}} (max refill of Applied to {{res?.dispense?.maxRefillApplied}})</p>
                                </div>
                                <div class="data-row">
                                  <p class="dr-head">No Of Refill</p>
                                  <p class="dr-content">{{res?.dispense?.noOfRefill ||'-'}}</p>
                                </div>
                                <div class="data-row">
                                  <p class="dr-head">Duration</p>
                                  <p class="dr-content">{{res?.dispense?.duration || '-'}}</p>
                                </div>
                              </td>
                              <td style="min-width: 200px;">
                                <div class="data-row">
                                  <p class="dr-head">Trade Name</p>
                                  <p class="dr-content">{{res?.dispense?.tradeName ||'-'}}</p>
                                </div>
                                <div class="data-row">
                                  <p class="dr-head">Package Size</p>
                                  <p class="dr-content">{{res?.dispense?.packageSize || '-'}}</p>
                                </div>
                                <div class="data-row">
                                  <p class="dr-head">Number of Packets</p>
                                  <p class="dr-content">{{res?.dispense?.noOfPacket ||'-'}}</p>
                                </div>
                                <div class="data-row">
                                  <p class="dr-head">Remaining Quantity</p>
                                  <p class="dr-content">{{res?.dispense?.remainingQuantity || '0'}}
                                  </p>
                                </div>
                                <div class="data-row">
                                  <p class="dr-head">Refill Can Be From Day</p>
                                  <p class="dr-content">{{res?.dispense?.nextRefillInDays || '-'}}
                                  </p>
                                </div>
                                <div class="data-row">
                                  <p class="dr-head">Total Price In Last Dispense</p>
                                  <p class="dr-content">{{res?.dispense?.totalPrice || '-'}}</p>
                                </div>

                              </td>
                              <td style="min-width: 200px;">
                                <div class="data-row">
                                  <p class="dr-head">Package Type</p>
                                  <p class="dr-content">{{res?.dispense?.packageType ||'-'}}</p>
                                </div>
                                <div class="data-row">
                                  <p class="dr-head">Size</p>
                                  <p class="dr-content">{{res?.dispense?.size ||'-'}}</p>
                                </div>
                                <div class="data-row">
                                  <p class="dr-head">Total Dispensed</p>
                                  <p class="dr-content">{{res?.dispense?.dispensedQuantity ||
                                    '0'}}</p>
                                </div>
                                <div class="data-row">
                                  <p class="dr-head">Allow Refill</p>
                                  <p class="dr-content" *ngIf="res?.dispense?.allowRefill == '1'">
                                    True</p>
                                  <p class="dr-content" *ngIf="res?.dispense?.allowRefill == '0'">
                                    False</p>
                                </div>
                                <div class="data-row">
                                  <p class="dr-head">Drug In Hand</p>
                                  <p class="dr-content">{{res?.dispense?.drugInHand || '0'}}</p>
                                </div>

                                <div class="data-row">
                                  <p class="dr-head">Dispense Status</p>
                                  <span *ngIf="res.dispenseStatus===null">-</span>
                                  <span class="status-rd not-dispensed" *ngIf="res.dispenseStatus===0">Cancelled</span>
                                  <span class="status-rd dispensed" *ngIf="res.dispenseStatus===2">Dispensed</span>
                                  <span class="status-rd opened" *ngIf="res.dispenseStatus===1">Open</span>
                                  <span class="status-rd partially-dispensed" *ngIf="res.dispenseStatus===3">Partially
                                    Dispensed</span>
                                </div>
                              </td>
                              <td style="min-width: 500px;" class="border-td pad-remove">
                                <ng-container *ngFor="let val of res?.requestValidation">
                                  <div class="bg-pass d-flex justify-content-between"
                                    *ngIf="checkValidationSataus(val.validationStatus)">
                                    <p>{{val.validationMessage}}</p>
                                    <div class="test-case pass"><img src="assets/images/icons/test-case-pass.svg"
                                        alt="Pass image">Pass</div>
                                  </div>

                                  <div class="bg-fail d-flex justify-content-between"
                                    *ngIf="!checkValidationSataus(val.validationStatus)">
                                    <p>{{val.validationMessage}}</p>
                                    <div class="test-case fail"><img src="assets/images/icons/test-case-fail.svg"
                                        alt="fail image">Fail</div>
                                  </div>
                                </ng-container>

                              </td>
                              <td style="min-width: 500px;" class="border-td pad-remove">
                                <ng-container *ngFor="let val of res?.capValidation">
                                  <div class="bg-pass d-flex justify-content-between"
                                    *ngIf="checkValidationSataus(val.validationStatus)">
                                    <p>{{val.capValidationMessage | notEmpty}}</p>
                                    <div class="test-case pass"><img src="assets/images/icons/test-case-pass.svg"
                                        alt="Pass image">Pass</div>
                                  </div>

                                  <div class="bg-fail d-flex justify-content-between"
                                    *ngIf="!checkValidationSataus(val.validationStatus)">
                                    <p>{{val.capValidationMessage| notEmpty}}</p>
                                    <div class="test-case fail"><img src="assets/images/icons/test-case-fail.svg"
                                        alt="fail image">Fail</div>
                                  </div>
                                </ng-container>
                              </td>
                              <td style="min-width: 210px;" class="dispense-td-update">
                                <div class="status" *ngIf="res.activityApprovalStatus===null"><span></span>-</div>
                                <div class="d-flex  align-items-center" *ngIf="res.activityApprovalStatus===0">
                                  <div class="status dark-red-circle-status"><span></span>Rejected </div>
                                  <a class="res-tool-wrap" *ngIf="res.approvalComment?.length"><img
                                      src="assets/images/icons/message.svg" alt="">
                                    <span class="custom-tooltip tooltip-top" role="tooltip">
                                      <span class="arrow"></span>
                                      <span class="tooltip-inner" [innerHTML]="res.approvalComment"></span>
                                    </span>
                                  </a>
                                </div>
                                <div class="d-flex  align-items-center" *ngIf="res.activityApprovalStatus===1">
                                  <div class="status navy-blue-circle-status" *ngIf="!res.isOverridden">
                                    <span></span>Approved
                                  </div>
                                  <div class="status navy-blue-circle-status" *ngIf="res.isOverridden">
                                    <span></span>Approved(Overridden)
                                  </div>
                                  <a class="res-tool-wrap" *ngIf="res.approvalComment?.length"><img
                                      src="assets/images/icons/message.svg" alt="">
                                    <span class="custom-tooltip tooltip-top" role="tooltip">
                                      <span class="arrow"></span>
                                      <span class="tooltip-inner" [innerHTML]="res.approvalComment"></span>
                                    </span>
                                  </a>
                                </div>
                                <!-- <div class="status yellow-circle-status" *ngIf="res.activityApprovalStatus===2">
                                  <span></span>Partially Approved
                                </div> -->
                                <div class="d-flex  align-items-center" *ngIf="res.activityApprovalStatus===2">
                                  <div class="status red-circle-status"><span></span>Cancelled </div>
                                  <a class="res-tool-wrap" *ngIf="res.approvalComment?.length"><img
                                      src="assets/images/icons/message.svg" alt="">
                                    <span class="custom-tooltip tooltip-top" role="tooltip">
                                      <span class="arrow"></span>
                                      <span class="tooltip-inner" [innerHTML]="res.approvalComment"></span>
                                    </span>
                                  </a>
                                </div>
                              </td>
                              <td style="min-width: 330px;" class="border-td">
                                <ng-container *ngIf="res.activityApprovalStatus!==2">
                                  <div class="btn-action-response d-flex align-items-center">
                                    <button class="btn btn-approve" [disabled]="res.activityApprovalStatus===1"
                                      [ngClass]="{'disabled' : res.activityApprovalStatus===1}"
                                      (click)="updateStatus(res?.dispense?.prescriptionActivityId,1,index)">
                                      <img src="assets/images/icons/tick-white.svg" alt="">
                                      Approve
                                    </button>
                                    <button class="btn btn-reject"
                                      (click)="updateStatus(res?.dispense?.prescriptionActivityId,0,index)"
                                      [disabled]="res.activityApprovalStatus===0"
                                      [ngClass]="{'disabled' : res.activityApprovalStatus===0}">
                                      <img src="assets/images/icons/close-icon-white.svg" alt="">
                                      Reject
                                    </button>
                                    <button class="btn btn-reject"
                                      (click)="updateStatus(res?.dispense?.prescriptionActivityId,2,index)">
                                      <img src="assets/images/icons/close-icon-white.svg" alt="">
                                      Cancel
                                    </button>
                                  </div>
                                  <textarea placeholder="Add Comment…" id="commentAdd" [(ngModel)]="description[index]"
                                    (ngModelChange)="addComment($event)" class="form-control min-height-text-area"
                                    [ngClass]="{'is-invalid' :addComment(description[index]) && isStatusUpdated[index]}">
                                  </textarea>
                                  <div class="invalid-feedback d-block"
                                    *ngIf="addComment(description[index])  && isStatusUpdated[index]">
                                    Please add a comment
                                  </div>
                                  <div class="btn-action-footer">
                                    <button class="btn btn-clear" (click)="clearComment(index)">Clear</button>
                                  </div>
                                </ng-container>

                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="no-data with-border" *ngIf="!prescriptionResponse?.length">
              <img src="./assets/images/icons/no-data-img.svg" alt="">
              <p>No Results Found</p>
            </div>
            <div class="table-footer mb-4">
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <div class="no-data with-border" *ngIf="!show">
      <img src="./assets/images/icons/no-data-img.svg" alt="">
      <p>No Results Found</p>
    </div>
  </div>
</main>